"use strict";

module.exports = function (url) {
  var a = document.createElement("a");
  return a.href = url, a;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVybFRvTG9jYXRpb24uanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsInVybCIsImEiLCJkb2N1bWVudCIsImNyZWF0ZUVsZW1lbnQiLCJocmVmIl0sIm1hcHBpbmdzIjoiOztBQUFBQSxNQUFBQSxDQUFPQyxPQUFQRCxHQUFpQixVQUFVRSxHQUFWLEVBQVVBO0FBQ3pCLE1BQUlDLENBQUFBLEdBQUlDLFFBQUFBLENBQVNDLGFBQVRELENBQXVCLEdBQXZCQSxDQUFSO0FBRUEsU0FEQUQsQ0FBQUEsQ0FBRUcsSUFBRkgsR0FBU0QsR0FBVEMsRUFDT0EsQ0FBUDtBQUFPQSxDQUhUSCJ9